import { render, staticRenderFns } from "./PharmacyMedicationCards.vue?vue&type=template&id=0c3413e2&"
import script from "./PharmacyMedicationCards.vue?vue&type=script&lang=ts&"
export * from "./PharmacyMedicationCards.vue?vue&type=script&lang=ts&"
import style0 from "./PharmacyMedicationCards.vue?vue&type=style&index=0&id=0c3413e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports